export enum BodyDataUnit {
    cm = 'cm',
    mm = 'mm',
    kg = 'kg',
    g = 'g',
    percent = '%'
}